import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild, ChangeDetectorRef} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Form, FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, delay, Observable, retry, Subject} from 'rxjs';


import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';


import { SubjectInvoice } from './../../../shared/models/subjectInvoice.model';
import { SubjectInvoiceItem } from './../../../shared/models/subjectInvoiceItem.model';
import { Payment } from './../../../shared/models/payment.model';

import { NgForm } from '@angular/forms';
import {WorkOrdersGridComponent} from './../../../components/grid/work-orders-grid/work-orders-grid.component';
import { SubjectWorkOrderItem } from 'src/app/shared/models/subjectWorkOrderItem.model';
import { SubjectWorkOrder } from 'src/app/shared/models/subjectWorkOrder.model';
import { MyobServicePurchase } from 'src/app/models/myob-service-purchase.model';

@Component({
  selector: 'app-myob-api-purchase-sync-tools-widget',
  templateUrl: './myob-api-purchase-sync-tools-widget.component.html',
  styleUrls: ['./myob-api-purchase-sync-tools-widget.component.css'],
  providers: [WorkOrdersGridComponent] // was throwing a no proders warning when adding as a module. (see if not have to entire in app.) FIXED!!!!!!!
})
export class MyobApiPurchaseSyncToolsWidgetComponent implements OnInit, OnChanges {
  

    // setup as observable?
    @Input() item_id?: Observable<any[]>; // impliments on changes.
    @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
    @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
    @Input() item_user_level_id? = '5'; // default to agent just in case
    @Input() item_brand_type_id? = '';
    @Input() show_buttons? = 'no'; // yes | no
    @Input() widget_title? = '';
    @Input() widget_size? = 'side'; // side | abstract | full | grid check
 
    job: Object;
    @Input() job_id: Observable<any[]>; 
    @Input() subject_id: Observable<any[]>; 
    @Input() subject_number?: Observable<any[]>;
    @Input() job_number: Observable<any[]>;
    @Input() invoice_id: Observable<any[]>;
    @Input() work_order_id: Observable<any[]>;
  
  // access the template form
  @ViewChild('invoiceForm') invoiceForm: NgForm;

   @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
   @Output('closeParentModel2') closeParentModel2: EventEmitter<any> = new EventEmitter();
    @Output('refreshInvoiceItemsBelow') refreshInvoiceItemsBelow: EventEmitter<any> = new EventEmitter();
   @Output('refreshWorkOrderItemsBelow') refreshWorkOrderItemsBelow: EventEmitter<any> = new EventEmitter();

 sessionUserId: any;
 sessionUsername: any;
 sessionBrandId: any;
 all_router_details: string;
 valueDatePickerDate: Date;
 today: string | number | Date;
 brand_invoice_id: any;
 invoice_job_type_id: any;
 invoice_item_model: any;
 invoiceItemsList: Object;
 subject: Object;
 invoice_model: any;
 invoiceItem: any;
 invoice_number: any;
 owner_brand: Object;
 invoice_status: Object;
 invoice_status_name: any;
 invoice_status_var: any;
 invoice_payment_status: Object;
 invoice_payment_status_name: any;
 invoice_payment_status_var: any;
 invoice_communication_status: Object;
 invoice_communication_status_name: any;
 invoice_communication_status_var: any;
 invoice_status_all: Object;
 invoice_payment_status_all: Object;
 invoice_communication_status_all: Object;
 original_invoice_status: any;
 original_invoice_payment_status: any;
 original_invoice_communication_status: any;
  work_order_status_all: Object;
  work_order_payment_status_all: Object;
  work_order_communication_status_all: Object;
  workOrderItem: any;
  work_order_number: any;
  work_order_status: Object;
  work_order_status_name: any;
  work_order_status_var: any;
  work_order_payment_status: Object;
  work_order_payment_status_name: any;
  work_order_payment_status_var: any;
  work_order_communication_status: Object;
  work_order_communication_status_name: any;
  work_order_communication_status_var: any;
  response_from_node: string;
  response_from_node_raw: any;
  error_message: any;
  error_name: any;
  full_response_data: any;
  data_sent: any;
  data_sent_id: any;
  data_sent_DisplayID: any;
  full_response_status: any;
  full_response_header
  full_response_headers: any;
  full_response: any;
  error_message_standard: any;
  data_sent_client_brand_id: any;
  data_sent_agent_brand_id: any;
  data_sent_invoice_id: any;
  data_sent_invoice_UID: any;
  data_sent_client_invoice_id: any;
  data_sent_agent_invoice_id: any;
  data_sent_invoice_payment_id: any;
  data_sent_work_order_payment_id: any;
  data_sent_work_order_id: any;
  data_sent_work_order_UID: any;
  data_sent_work_order_spending_id: any;

  original_work_order_status: any;
  original_work_order_payment_status: any;
  original_work_order_communication_status: any;
  myob_checker: Object;
  myob_response;

      // sees if there is a change in myCount
      @Output() change: EventEmitter<any> = new EventEmitter<any>();
      // New event emitter to show the results of api calls to other modules from this component as sendResponse() results.. set response_from_node
        @Output('sendResponse') sendResponse: EventEmitter<any> = new EventEmitter();
        @Output() test_message: EventEmitter<any> = new EventEmitter<any>();
      
      

  myob_account_codes: Object;
  myob_tax_codes: Object;
  
work_orderItemsList: any = SubjectWorkOrderItem;


  myobInvoiceUpdateData: any;
  myobInvoiceUpdatedData: any;

  work_order_model: SubjectInvoice = new SubjectWorkOrder();
  work_order_item_model: any = SubjectWorkOrderItem;
  data_work_order: any = MyobServicePurchase;
  brand: any;
  brandData: any;
  myobWorkOrderCreatedData: any;
  myobWorkOrderListMapped: any;
  set_RowVersion: any;
  modalRef: any;

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef,
     private router: Router, 
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
     private cdr:ChangeDetectorRef, // allows for change detection once pushed data to an array
     public _WorkOrdersGridComponent: WorkOrdersGridComponent
  ) {
          // Set and Access login Session Variables
      this.gfunc.setLoginSessionVars(); // set in a global function file
      this.sessionUserId = this.gfunc.currentUserVAR.user_id;
      this.sessionUsername = this.gfunc.currentUserVAR.username;
      this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

        // need to add this as routes does not work globally
        this.all_router_details = this.router.url;
        this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

      // Date picker date format
      this.valueDatePickerDate = new Date(this.today);
     
   }



    // check for changes. to load data.
 ngOnChanges(changes) {

        if (changes.work_order_id) {
        this.work_order_id = changes.work_order_id.currentValue;
                // this.getJobSubject(this.subject_id);
                // this.getJob(this.job_id);
                // // this.getWorkOrderStatusAll();
                // // this.getInvoiceStatusAll();
                // this.getWorkOrderPaymentStatusAll();
                // // this.getInvoiceCommunicationStatusAll();
                // // this.getInvoice(this.invoice_id);
        this.getWorkOrder(this.work_order_id);
        // load these so that push to myob works from external compoent functions
        this.getMyobAccountCodes();
        this.getMyobTaxCodes();
        // this.myob_response = true;
        // this.myobChecker();
        }


        if (changes.item_id) {
          //  this.job_id = changes.item_id.currentValue;
          }
        }


  ngOnInit() {
  }





  getWorkOrder(work_order_id){
    this._demoService.getSubjectWorkOrder(work_order_id).subscribe(
      (data) => {
        this.workOrderItem = data;
        let res = data[0];
        this.work_order_number = res.work_order_number;
      },
      (err) => console.error(err),
     () => {} // console.log('Brand Loaded.')
    ); };



    myobChecker() {
      this._demoService.myobChecker().subscribe(
         data => { this.myob_checker = data;
          // let res = data[0];
          // this.toastr.success('Myob Connections Active!... functions allowed');
    // console.log('Connected: ', JSON.stringify(this.myob_checker));
    this.myob_response = true;
        },
         err => (
          // this.toastr.success('Myob Connections Not Active! Please connect again.', err.error),
          this.myob_response = false,
          console.error(err)
         ),
         // () => console.log('done loading Trace Types')
       );
     }



// New oFficial Agent Sycn Functions feb 15t 2023

setMyobWorkOrderModelStep1(model){
  // set these so they are available to extermanl components.
  this.getMyobTaxCodes(); // load this onInit.
  this.getMyobAccountCodes();

// this.invoice_item_model = null;
this.getWorkOrderItmes(model.work_order_id, model);
      // (async () => {
      //   await this.delay(8000);
      //  })(); // end async function
  };

  // Get Invoice Items
  getWorkOrderItmes(work_order_id, model){
    this._demoService.getSubjectWorkOrderItems(work_order_id)
    .subscribe(
      (data) => {
        this.work_orderItemsList = data;
        const res = data[0];
        this.work_order_item_model = this.work_orderItemsList;
       // move dto below...
    

        // this.doCalculations();
      },
      (err) => {
         console.error(err)
                 // Need to set some error varibles
                 this.error_message = err.error.error_message;
                 this.error_message_standard = err.error.error_message_standard;
                 this.error_name = err.error.error_name;
                 this.full_response_data = err.error.full_response_data;
                 this.data_sent = err.error.data_sent;
                 this.data_sent_id = err.error.data_sent_invoice_id;
       
                
       
                 this.response_from_node = JSON.stringify(err)
                 this.response_from_node_raw = err;
                //  this.sendResponse.emit(this.response_from_node);
                 console.log(' getWorkOrderItmes(work_order_id, model): ' + this.response_from_node)
                //  this.test_message = this.response_from_node; // could be as simple as this?
                 return(this.response_from_node = JSON.stringify(err)); // do this so other componets get
      

       
      },
     () => { 
      this.setMyobWorkOrderModelStep2(model); // ru
      console.log('Work Order Items Loaded.')
    }
    ); };




    setMyobWorkOrderModelStep2(model){
      this._demoService.getBrandById(model.agent_id).subscribe(
          data => { this.brand = data;
          const  res = data[0];
                            this.brandData = res;
                      console.log('Brand MyobID: ' + res.myob_id);
                      console.log('Brand ID MYOB: ' + this.brandData.myob_id);
                      console.log('Invoice Items: ' + JSON.stringify(this.invoice_item_model));
                      // Invoice Model.- use return so that model is available in the outside subscription
     
     // Meed to get a model of the Tax Code ID
     // Memo if a subject or job invoice
     const JournalMemo = 'Agent Invoice';
     
     
     let BillDeliveryStatus;
     if (model.invoice_communication_status_id === 1) { // email
      BillDeliveryStatus = 'Nothing';
     }else{
      BillDeliveryStatus = 'Print';
     }
     let ShipToAddress = this.brandData.address_1 + ' ' + this.brandData.address_2 + ' ' + this.brandData.suburb + ' ' + 
                         this.brandData.state + ' ' + this.brandData.postcode + ' ' + this.brandData.country;
     

      // Due Date Function June 2025 to remove time zones from date.
       let myob_format_date_created = this.gfunc.parseMyobDate(model.date_created)
       let myob_format_date_due = this.gfunc.parseMyobDate(model.due_date)
                   
     
                      this.data_work_order = {
                      'Number': model.work_order_number, //  model.invoice_number
                       // 'Date': model.date_created,
 'Date': myob_format_date_created, // new format june 2025
                      'SupplierInvoiceNumber': model.SupplierInvoiceNumber,
                      'Supplier': {
                      'UID': this.brandData.myob_id
                      },
                      'ShipToAddress': ShipToAddress ,
                      'Terms': {
                      'PaymentIsDue': 'DayOfMonthAfterEOM',
                      'DiscountDate': 1,
                      'BalanceDueDate': 30,
                      'DiscountForEarlyPayment': 0,
                      'MonthlyChargeForLatePayment': 0,
                      'DiscountExpiryDate': model.due_date,
                      'Discount': 0,
                      'DueDate': model.due_date
                      },
                      'IsTaxInclusive': true,
                      'IsReportable': true,
     
                      'Lines': [
                      // {
                      // 'Type': '',
                      // 'Description': '' ,
                      // 'Account': {
                      // 'UID': 'd92626b4-1cbb-4ac9-8b46-856175f5c0a7'
                      // },
                      // 'Total': 6,
                      // 'Job': null,
                      // 'TaxCode': {
                      // 'UID': '8d273078-fe1d-4c16-b318-ec7a2b7fb2fe'
                      // }
                      // },
                      ],
     
                      'Subtotal': model.work_order_subtotal,
                      'Freight': 0,
                      'FreightTaxCode': {
                      'UID': this.gfunc.myob_FreightTaxCode
                      },
                      'TotalTax': model.work_order_gst,
                      'TotalAmount': model.work_order_total,
                      'Category': null,
                      'Comment': '',
                      'ShippingMethod': null,
                      'PromisedDate': null,
                      'JournalMemo': 'SOP: ' + JournalMemo + ' ' + model.work_order_number,
                      'BillDeliveryStatus': BillDeliveryStatus,
                      'AppliedToDate': 0,
                      'BalanceDueAmount': model.work_order_remaining_total,
                      'Status': 'Open',
                      'LastPaymentDate': null,
                      'Order': null,
                      'ForeignCurrency': null
                      };
     
         // :: This function Collects and pushes the lines to the rows of the invoice.
                      // console.log('Invoice Items: 2 ' + JSON.stringify(this.invoiceItemsList));
                      // need to loop through the invoice model and create Lines.
     
        const newArr = Object(this.work_order_item_model).filter((sbi) => (1 === 1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
     
                      const  count_of_items = Object.keys(newArr).length;
                      //  let res = data[0];
                      // Run the job data queries.
                      // need to do a loop of subject_billing items (.length)
                      for (let i = 0; i < count_of_items; i++) {
                        const res = newArr[i];
     
     
        // get a list of all the account ID/s in an array  -- THIS WORKS SO WELL!!!!!!
                      // this.getMyobTaxCodes(); // load this onInit.
                      // this.getMyobAccountCodes();
     
     // DISABLED BELOW FOR ERROR TESTING ONNLY.
     
     const retTaxCodeUID = Object(this.myob_tax_codes).filter((mtc) => (mtc.myob_tax_code_id === res.myob_tax_code_id ));
     const retAccountUID = Object(this.myob_account_codes).filter((mac) => (mac.myob_account_code_id === res.myob_account_code_id ));
     // console.log('Tax Acc: ' + JSON.stringify(retTaxCodeUID));
     // console.log('Myob Acc: ' + JSON.stringify(retAccountUID));
     
     const TaxAccountUID = retTaxCodeUID[0].UID;
     const MyobAccountUID = retAccountUID[0].UID;
     
     console.log('Tax Code: ' + retTaxCodeUID[0].UID);
     console.log('Acc Code: ' + retAccountUID[0].UID);
     
                        const new_line = {
                          // 'RowID': res.invoice_item_id, // see if this works then I can  upate easier. /// no this failed.
                          'Type': 'Transaction',
                          'Description': res.cost_task_name,
                          'Account': {
                          'UID': MyobAccountUID,
                          // 'UID': res.myob_account_code_id,
                          },
                          'Total': res.total,
                          'Job': null,
                          'TaxCode': {
                          'UID': TaxAccountUID
                          // 'UID': res.myob_tax_code_id,
                          }
                          };
     
                      this.data_work_order.Lines.push(new_line);
                      }
     
                      console.log('New Pushed Model: ' + JSON.stringify(this.data_work_order));

               this.createMyobWorkOrderModel(model, this.data_work_order);


     
     
          },
          err => {
            // this.toastr.error('You need to login to MYOB again, Connection lost!');
           console.log(err.error);
    
    
    
                            // Need to set some error varibles
                            this.error_message = err.error.error_message;
                            this.error_message_standard = err.error.error_message_standard;
                            this.error_name = err.error.error_name;
                            this.full_response_data = err.error.full_response_data;
                            this.data_sent = err.error.data_sent;
                            this.data_sent_id = err.error.data_sent_invoice_id;
                  
                           
                  
                            this.response_from_node = JSON.stringify(err)
                            this.response_from_node_raw = err;
                            this.sendResponse.emit(this.response_from_node);
                            console.log('FullRespoonse Error Inside Tools 4: ' + this.response_from_node)
                            // this.test_message = this.response_from_node; // could be as simple as this?
                            return(this.response_from_node = JSON.stringify(err)); // do this so other componets get
                 
    
    
    
          },
          // () =>  {
          //  // console.log('Work Order model Loaded.');
          //   // console.log("made it here")
          // // this.createMyobWorkOrderModel(model, this.data_work_order);


          // }
        );
     
     }
     
     


// THIS IS NOT RETURNING THE ERRO CHECK TO SEE WHAT I DO FOR INVOICES AND IF I NEED TO CHANGE THIS

     createMyobWorkOrderModel(model, data_work_order) {
      // if (confirm('We are about to Sync this Work Order with MYOB, Are you Sure?')) {
    // console.log('Invoice Data: ' + JSON.stringify(data_work_order));
  
    if (this.data_work_order !== '{}' ) {
        this._demoService.createMyobWorkOrder(this.data_work_order)
        .pipe(
          retry(0), // you retry 3 times
          delay(1200) // each retry will start after 1 second,
       )
        .pipe(
          this.toastr.observe({
             loading: 'Connecting...Pushing data...Updating',
             success: '🚀',
             error: '😡 Please Check/View Supplier Invoice Directly & Push to see full error message :: ERROR :: ' + this.error_message
          })
        )
       .subscribe(
        data => { this.myobWorkOrderCreatedData = data;
          let res = data[0];
          const new_data_object = JSON.parse(this.myobWorkOrderCreatedData);
          const location_string = new_data_object.location;
          // get everything after last dash
          const slug = location_string.split('/').pop(); // 2020
          console.log('UUID slug: ' + slug);
  
                          // need to pass the brand model here as its updatting the full SOP brand details.
                          this._demoService.getMyobPurchaseMapped(slug, model)
                          .pipe(
                            retry(10), // you retry 3 times
                            delay(1200) // each retry will start after 1 second,
                         )
                          .subscribe(
                             data4 => {
                              console.log(data4);
                              res = data4[0];
                            // many
                              // this.myobContactListMapped = data.data;
                            // single
                              this.myobWorkOrderListMapped = data4;
                            // Set the returned Variables Reququied for Update of a Myob Customer.
                            console.log('UID: ' +  data4.UID);
                            console.log('LastModified: ' + data4.LastModified);
                            console.log('RowVersion: ' + data4.RowVersion);
                            // console.log('TaxCodeUID: ' +  data4.SellingDetails.TaxCode.UID);
                            // console.log('Sale Layout: ' +  data4.SellingDetails.SaleLayout);
  
  
                            // work out the nulls for sub arraryas
                            let CategoryUID;
                            let OrderUID;
                            let SalespersonUID;
  
                            if (typeof model.Category === 'undefined' || model.Category === null ) {
                              CategoryUID = null;
                            }else {
                              CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
                            };
                            if (typeof model.Order === 'undefined' || model.Order === null ) {
                              OrderUID = null;
                            }else {
                              OrderUID = model.Category.UID; // can only call if actuall exist in the array!
                            };
                            if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
                              SalespersonUID = null;
                            }else {
                              SalespersonUID = model.Category.UID; // can only call if actuall exist in the array!
                            };
  
  
                            this.set_RowVersion = data4.RowVersion;
                            // model.IsIndividual = data4.IsIndividual;
                            // model.SaleLayout = data4.SellingDetails.SaleLayout;
                            // model.InvoiceDelivery = data4.SellingDetails.InvoiceDelivery;
  
                            // model.TaxCode = data4.SellingDetails.TaxCode.UID;
                            // model.FreightTaxCode = data4.SellingDetails.FreightTaxCode.UID;
                            model.RowVersion = data4.RowVersion;
                            model.myob_array = JSON.stringify(data4);
                            model.myob_id = slug;
                            model.sync_with_myob = 1;
  
                            // All Additional Myon Invoice Variables
                           model = {
                             ...model,
                             ...data4 // returned results (Of Myob Insert)
                           };
  
                          // All Additional Myon Invoice Variables
                                        //  model.UID = data4.UID;
                                        //  model.Number = data4.Number;
                                        //  model.Date = data4.Date;
                                        //  model.CustomerPurchaseOrderNumber = data4.CustomerPurchaseOrderNumber;
                                        //  model.CustomerUID = data4.Customer.UID;
                                        //  model.CustomerName = data4.Customer.Name;
                                        //  model.CustomerDisplayID = data4.Customer.DisplayID;
                                        //  model.PromisedDate = data4.PromisedDate;
                                        //  model.BalanceDueAmount = data4.BalanceDueAmount;
                                        //  model.BalanceDueAmountForeign = data4.BalanceDueAmountForeign;
                                        //  model.Status = data4.Status;
                                        //  model.TermsPaymentIsDue = data4.Terms.PaymentIsDue;
                                        //  model.TermsDiscountDate = data4.Terms.DiscountDate;
                                        //  model.TermsBalanceDueDate = data4.Terms.BalanceDueDate;
                                        //  model.TermsDiscountForEarlyPayment = data4.Terms.DiscountForEarlyPayment;
                                        //  model.TermsMonthlyChargeForLatePayment = data4.Terms.MonthlyChargeForLatePayment;
                                        //  model.TermsDiscountExpiryDate = data4.Terms.DiscountExpiryDate;
                                        //  model.TermsDiscount = data4.Terms.Discount;
                                        //  model.TermsDueDate = data4.Terms.DueDate;
                                        //  model.TermsFinanceCharge = data4.Terms.FinanceCharge;
                                        //  model.IsTaxInclusive = data4.IsTaxInclusive;
                                        //  model.Subtotal = data4.Subtotal;
                                        //  model.SubtotalForeign = data4.SubtotalForeign;
                                        //  model.Freight = data4.Freight;
                                        //  model.FreightForeign = data4.FreightForeign;
                                        //  model.FreightTaxCodeUID = data4.FreightTaxCode.UID;
                                        //  model.TotalTax = data4.TotalTax;
                                        //  model.TotalTaxForeign = data4.TotalTaxForeign;
                                        //  model.TotalAmount = data4.TotalAmount;
                                        //  model.TotalAmountForeign = data4.TotalAmountForeign;
                                        //  model.CategoryUID = CategoryUID; // var
                                        //  model.SalespersonUID = SalespersonUID; // var
                                        //  model.Comment = data4.Comment;
                                        //  model.ShippingMethod = data4.ShippingMethod;
                                        //  model.JournalMemo = data4.JournalMemo;
                                        //  model.ReferralSource = data4.ReferralSource;
                                        //  model.InvoiceDeliveryStatus = data4.InvoiceDeliveryStatus;
                                        //  model.LastPaymentDate = data4.LastPaymentDate;
                                        //  model.CanApplySurcharge = data4.CanApplySurcharge;
                                        //  model.OrderUID = OrderUID; // var
                                        //  model.OnlinePaymentMethod = data4.OnlinePaymentMethod;
                                        //  model.ForeignCurrency = data4.ForeignCurrency;
                                        //  model.CurrencyExchangeRate = data4.CurrencyExchangeRate;
                                        //  model.LastModified = data4.LastModified;
                                        //  model.URI = data4.URI;
                                        //  model.RowVersion = data4.RowVersion;
  
  
  
                                            // TOD I NEED TO GET THE LINE ID's and RowVersions to be able to update the Invoice. I THink?
                                            // UPDATE the invoice Items RowID, RowVersion and other details.
                                                // HERE NOW
  
  
  
                                    // ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
                                     // tslint:disable-next-line:max-line-length
                                                      const newArr = Object(data4.Lines).filter((ii) => (1 === 1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
                                                      const  count_of_items = Object.keys(newArr).length;
                                                      //  let res = data[0];
                                                      // Run the job data queries.
                                                      // need to do a loop of subject_billing items (.length)
                                                      for (let i = 0; i < count_of_items; i++) {
                                                        const res = newArr[i];
  
                                                      // empty array of invoiceItemsList first
                                                      this.work_orderItemsList = {};
  
                                                        let TaxCodeUID;
                                                        let JobUID;
                                                        let AccountUID;
                                                        let TaxCodeCode;
  
                                                      console.log('TaxCodeUID:' +  res.TaxCode.UID);
  
                                                      // check for nulls on sub arrays
                                                      if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
                                                      TaxCodeUID = null;
                                                      TaxCodeCode = null;
                                                      }else {
                                                      TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
                                                      TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
                                                      };
                                                      if (typeof res.Job === 'undefined' || res.Job === null ) {
                                                      JobUID = null;
                                                      }else {
                                                      JobUID = res.Job.UID; // can only call if actuall exist in the array!
                                                      };
                                                      if (typeof res.Account === 'undefined' || res.Account === null ) {
                                                      AccountUID = null;
                                                      }else {
                                                      AccountUID = res.Account.UID; // can only call if actuall exist in the array!
                                                      };
  
                                                      this.work_orderItemsList = {
                                                      RowID: res.RowID,
                                                      Type: res.Type,
                                                      Description: res.Description,
                                                      UnitOfMeasure: res.UnitOfMeasure,
                                                      UnitCount: res.UnitCount,
                                                      UnitPrice: res.UnitPrice,
                                                      UnitPriceForeign: res.UnitPriceForeign,
                                                      DiscountPercent: res.DiscountPercent,
                                                      Total: res.Total,
                                                      TotalForeign: res.TotalForeign,
                                                      AccountUID: AccountUID, // var
                                                      JobUID: JobUID, // var
                                                      TaxCodeUID: TaxCodeUID, // var
                                                      TaxCodeCode: TaxCodeCode, // var
                                                      RowVersion: res.RowVersion
                                                            };
  
                                                      console.log('work_orderItemsUpdateModel: ' + JSON.stringify(this.work_orderItemsList));
                                                      // this.invoiceItemsList = this.invoiceItemsList;
                                                      if (this.work_orderItemsList !== '{}') {
                                                        // we udate each item in the loop that was just inserted.
                                                      this.updateSubjectWorkOrderItem(this.work_orderItemsList, model.work_order_id);
                                                      };
                                                      } // End Lines Loop
  
                                            // Now run the actual invoice model update.
                                            this.updateSubjectWorkOrder(model);  // updates the invoice
  
                            this.toastr.info('Invoice + Items Vrs Upgraded In SOP');
                            // this.refreshGrid();
              
                          },
                          err => {
                            // console.error('Error saving Event!');
                            //  this.toastr.error('Error Updating Invoice to Myob Details');
                            console.log(err.error);
  
                            // Need to set some error varibles
                            this.error_message = err.error.error_message;
                            this.error_message_standard = err.error.error_message_standard;
                            this.error_name = err.error.error_name;
                            this.full_response_data = err.error.full_response_data;
                            this.data_sent = err.error.data_sent;
                            this.data_sent_id = err.error.data_sent_invoice_id;
                  
                          
                  
                            this.response_from_node = JSON.stringify(err)
                            this.response_from_node_raw = err;
                            this.sendResponse.emit(this.response_from_node);
                            console.log('FullRespoonse Error createMyobWorkOrderModel(model, data_work_order): ' + this.response_from_node)
                            // this.test_message = this.response_from_node; // could be as simple as this?
                            return(this.response_from_node = JSON.stringify(err)); // do this so other componets get
        
  
  
  
  
                           });
  
                              // console.log(this.myobCustomerCreatedData.location);
                              // // https://www.concretepage.com/questions/577
                              //  this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
                              //  // console.log(this.arrCase);
                              //  this.Items = data['Items'] ;
          this.toastr.info('Work Order Inserted + Vrs Updated.');
          // redirect back to the work order page.
          // this.gfunc.globalJobSubjectCostViewSkipRoute(this.data_work_order[0].subject_id)
  
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
         console.log(err.error);
  
  
  
                          // Need to set some error varibles
                          this.error_message = err.error.error_message;
                          this.error_message_standard = err.error.error_message_standard;
                          this.error_name = err.error.error_name;
                          this.full_response_data = err.error.full_response_data;
                          this.data_sent = err.error.data_sent;
                          this.data_sent_id = err.error.data_sent_invoice_id;
                
                         
                
                          this.response_from_node = JSON.stringify(err)
                          this.response_from_node_raw = err;
                          this.sendResponse.emit(this.response_from_node);
                          console.log('FullRespoonse Error Inside Tools 4: ' + this.response_from_node)
                          // this.test_message = this.response_from_node; // could be as simple as this?
                          return(this.response_from_node = JSON.stringify(err)); // do this so other componets get
               
  
  
  
        },
        // () => console.log('done loading Trace Types')
      );
    }// end if invoice_data
  
      // }; // end confirm
    };
  
  




    updateSubjectWorkOrderItem(model, work_order_id){
      this._demoService.updateSubjectWorkOrderItemByDescription(model, work_order_id).subscribe(
        data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
          // let res = data[0];
        // this.router.navigate(['../../companies'], { relativeTo: this.route });
         return true;
        },
        err => {
          console.error(err);


                 // Need to set some error varibles
                 this.error_message = err.error.error_message;
                 this.error_message_standard = err.error.error_message_standard;
                 this.error_name = err.error.error_name;
                 this.full_response_data = err.error.full_response_data;
                 this.data_sent = err.error.data_sent;
                 this.data_sent_id = err.error.data_sent_invoice_id;
       
                
       
                 this.response_from_node = JSON.stringify(err)
                 this.response_from_node_raw = err;
                 this.sendResponse.emit(this.response_from_node);
                 console.log('FullRespoonse Error Inside Tools: ' + this.response_from_node)
                //  this.test_message = this.response_from_node; // could be as simple as this?
                 return(this.response_from_node = JSON.stringify(err)); // do this so other componets get
      

       //  this.toastr.error('Adding Failed :: Please try again!');
         // console.log(Observable.throw(error));
          // return Observable.throw(error);
        }
    );
     }




     updateSubjectWorkOrder(work_order_model){
      this._demoService.updateSubjectWorkOrder(work_order_model)
      .pipe(
        retry(10), // you retry 3 times
        delay(1200) // each retry will start after 1 second,
     )
      .subscribe(
        data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
          // let res = data[0];
        // this.router.navigate(['../../companies'], { relativeTo: this.route });
      // this.toastr.success('Local SupplierInvoice/WO Updated');
         return {messsag:"all done..."};
        },
        err => {
  
  console.log(err.error);
                   // Need to set some error varibles
                   this.error_message = err.error.error_message;
                   this.error_message_standard = err.error.error_message_standard;
                   this.error_name = err.error.error_name;
                   this.full_response_data = err.error.full_response_data;
                   this.data_sent = err.error.data_sent;
                   this.data_sent_id = err.error.data_sent_invoice_id;
         
                  
         
                   this.response_from_node = JSON.stringify(err)
                   this.response_from_node_raw = err;
                   this.sendResponse.emit(this.response_from_node);
                   console.log('FullRespoonse Error Inside Tools 4: ' + this.response_from_node)
                  //  this.test_message = this.response_from_node; // could be as simple as this?
                   return(this.response_from_node = JSON.stringify(err)); // do this so other componets get
        
  
  
          
       //  this.toastr.error('Adding Failed :: Please try again!');
         // console.log(Observable.throw(error));
          // return Observable.throw(error);
        }
    );
     }




  getMyobAccountCodes() {
    this._demoService.getMyobAccountCodes().subscribe(
       data => { this.myob_account_codes = data;
        const res = data[0];
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getMyobTaxCodes() {
    this._demoService.getMyobTaxCodes().subscribe(
       data => { this.myob_tax_codes = data;
        const res = data[0];
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}






}
